<template>
  <div class="control-icons-container">
    <div class="control-icon">
      <card-tooltip :width="120">
        <cs-icon slot="trigger" :name="visibilityIcon" color="#000" />
        <span v-html="displayProjectPermissionText"></span>
      </card-tooltip>
    </div>
    <div class="control-icon" @click.stop="$emit('disable')">
      <card-tooltip :width="140">
        <cs-icon slot="trigger" name="power" color="#000" />
        <span v-html="displayProjectDisconnectText"></span>
      </card-tooltip>
    </div>
  </div>
</template>

<script>
import CardTooltip from './CardTooltip';

export default {
  name: 'ProjectControls',
  components: {
    CardTooltip,
  },
  props: {
    permission: {
      type: Boolean,
      required: true,
    },
    pending: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    visibilityIcon() {
      if (this.pending) {
        return 'eye-close';
      }

      return this.permission ? 'eye-open' : 'eye-close';
    },
    displayProjectPermissionText() {
      return this.permission ? this.$t('access.to.partner.transactions') : this.$t('no.access.to.partner.transactions');
    },
    displayProjectDisconnectText() {
      return this.$t('turn.off.project.from.partners.program');
    },
  },
};
</script>

<style lang="sass" scoped>
  .control-icons-container
    display: flex
    position: absolute
    right: 20px
    top: 17px
    cursor: pointer

    .control-icon
      position: relative

      &:not(:last-child)
        margin-right: 12px
</style>
